module.exports = __webpack_public_path__ + "static/Truck14-9166bbb69d890a3d862d8a8116ba95df.png";